import { createReducer, on } from '@ngrx/store';
import { AdminOrganizationsApiActions, AdminOrganizationsPageActions } from '../actions';

export const adminOrganizationsPageFeatureKey = 'adminOrganizationsPage';

export interface State {
  error: any;
  pending: boolean;
}

export const initialState: State = {
  error: null,
  pending: false
};

export const reducer = createReducer(
  initialState,
  on(AdminOrganizationsPageActions.listOrganizations, (state: State) => ({ ...state, error: null, pending: true })),
  on(AdminOrganizationsApiActions.listOrganizationsSuccess, (state: State) => ({ ...state, error: null, pending: false })),
  on(AdminOrganizationsApiActions.listOrganizationsFailure, (state: State, { error }) => ({ ...state, error, pending: false })),
  on(AdminOrganizationsPageActions.updateOrganization, (state: State) => ({ ...state, error: null, pending: true })),
  on(AdminOrganizationsApiActions.updateOrganizationSuccess, (state: State) => ({ ...state, error: null, pending: false })),
  on(AdminOrganizationsApiActions.updateOrganizationFailure, (state: State, { error }) => ({ ...state, error, pending: false })),
  on(AdminOrganizationsPageActions.addOrganization, (state: State) => ({ ...state, error: null, pending: true })),
  on(AdminOrganizationsApiActions.addOrganizationSuccess, (state: State) => ({ ...state, error: null, pending: false })),
  on(AdminOrganizationsApiActions.addOrganizationFailure, (state: State) => ({ ...state, error: null, pending: false }))
);

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
